import { useState, useMemo, useEffect } from "react";
import { getMaxPossibleStep, steps, StepsEnum } from "./utils";
import { useApplication } from "src/context/ApplicationContext";
import Navigation from "src/components/Navigation";
// Steps
import PersonalDetails from "src/components/step/PersonalDetails";
import EqualOpportunities from "src/components/step/apply/EqualOpportunities";
import EducationHistory from "src/components/step/apply/EducationHistory";
import MoreAboutYou from "src/components/step/apply/MoreAboutYou";
import Declaration from "src/components/step/apply/Declaration";

const Apply = () => {
  // Form State
  const { id, data, onUpdate, onSubmit } = useApplication();

  // Step State
  const maxPossibleStep = getMaxPossibleStep(data);
  const [activeStep, setActiveStep] = useState(maxPossibleStep);

  // Update Form
  const handleUpdate = (nextStep) => (formData) => {
    onUpdate(formData);
    setActiveStep(nextStep);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [activeStep]);

  const CurrentStep = useMemo(() => {
    switch (activeStep) {
      case StepsEnum.PersonalDetails:
        return (
          <PersonalDetails
            type="apply"
            data={data}
            onSubmit={handleUpdate(StepsEnum.EqualOpportunities)}
          />
        );
      case StepsEnum.EqualOpportunities:
        return (
          <EqualOpportunities
            data={data}
            onSubmit={handleUpdate(StepsEnum.EducationHistory)}
          />
        );
      case StepsEnum.EducationHistory:
        return (
          <EducationHistory
            data={data}
            onSubmit={handleUpdate(StepsEnum.MoreAboutYou)}
          />
        );
      case StepsEnum.MoreAboutYou:
        return (
          <MoreAboutYou
            id={id}
            data={data}
            onSubmit={handleUpdate(StepsEnum.Declaration)}
          />
        );
      case StepsEnum.Declaration:
        return <Declaration onSubmit={onSubmit} />;
    }
  }, [activeStep]);

  return (
    <>
      <Navigation
        activeStep={activeStep}
        maxPossibleStep={maxPossibleStep}
        steps={steps}
        onChange={setActiveStep}
      />

      {CurrentStep}
    </>
  );
};

export default Apply;
